<template>
  <div class="module-table">
    <el-table :data="moduleData" border size="small" class="data-table">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="上诉人姓名">
            <template slot-scope="scope">
              {{ scope.row.appellor_name || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="被上诉人姓名" min-width="180" >
            <template slot-scope="scope">
              {{ scope.row.appellor_name }}
            </template>
        </el-table-column>
        <el-table-column label="公告标题">
            <template slot-scope="scope">
              {{ scope.row.bulletin_title || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="案号">
            <template slot-scope="scope">
              {{ scope.row.case_number || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="案件类型名称">
            <template slot-scope="scope">
              {{ scope.row.case_type_name || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="经办法院">
            <template slot-scope="scope">
              {{ scope.row.operate_court_name || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="角色类型代码(破产重整企业)">
            <template slot-scope="scope">
              {{ scope.row.role_type_code === 1 ? '申请人':'被申请人' || '-' }}
            </template>
        </el-table-column>
        
    </el-table>
  </div>
</template>

<script>
export default {
    name: 'bankruptReformList',

    data() {
        return {
            title: '破产重组',
        }
    },  
    props: {
        moduleData: {
            type: Array,
            default: () => []
        }
    },
    methods: {
    }
}
</script>

<style scoped lang="scss">
// 表格铺满
.module-table {
  width: 100%;
  .el-table { 
    width: 100%;
  }
}
</style>